var Component = require("!../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../node_modules/vue-loader/lib/selector?type=script&index=0!./debug.vue"),
  /* template */
  require("!!../node_modules/vue-loader/lib/template-compiler?id=data-v-5af72c5c!../node_modules/vue-loader/lib/selector?type=template&index=0!./debug.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/debug.vue
// module id = 21
// module chunks = 0